import { createContext, ReactNode } from "react";
import { useGetSubscriptionsQuery } from "src/api/services/patientSubscriptionApi";
import { PatientSubscription } from "src/api/types";

export const PatientSubscriptionContext = createContext<
  PatientSubscription[] | undefined
>([]);

interface Props {
  children: ReactNode;
}

const PatientSubscriptionsProvider = ({ children }: Props) => {
  const { data, isLoading } = useGetSubscriptionsQuery();

  if (isLoading === true) {
    return null;
  }

  return (
    <PatientSubscriptionContext.Provider value={data}>
      {children}
    </PatientSubscriptionContext.Provider>
  );
};

export default PatientSubscriptionsProvider;
